import { ReactComponent as EditIcon } from '@/assets/icons/ri-edit-line.svg';
import Button from '@/components/common/Button';

const formatClosingHours = (schedules: { [key: string]: any }): {name: string, startHour: { start: number, end: number} }[] => {
	const closedCourts = schedules.reduce((acc, schedule) => {
		const courtId = schedule.venue_court_id
		if (!acc[courtId]) {
			acc[courtId] = []
		}
		acc[courtId].push(schedule)
		return acc
	}, {})
	return Object.values(closedCourts).map((closedCourt: { [key: string]: any }) => {
		const closedSchedule = {}
		const closedHours = []
		let courtName = ''
		closedCourt.forEach(court => {
			courtName = court.venue_court?.code || ''
			closedHours.push(court.start_time)
		})
		closedHours.sort((a,b) => a-b)
		let start = 0
		let end = 0
		closedHours.forEach((startHour) => {
			if (startHour === end) {
				end+=1
				closedSchedule[start].end = end
			} else {
				start = startHour
				end = startHour+1
				closedSchedule[start] = {
					start,
					end,
				}
			}
		})
		return {
			startHour: closedSchedule,
			name: courtName
		} as { name: string, startHour: {start: number, end: number} }
	})
}

export const renderReasonRow = (data: string) => (
	<div className="flex gap-4">
		<p className="font-bold text-sm text-black-primary">{data}</p>
	</div>
)

export const renderDetailRow = (data: ScheduleTableDetailParams[]) => {
	const closedDates = {}
	data.forEach((schedule: ScheduleTableDetailParams) => {
		if (closedDates[schedule.date]) {
			closedDates[schedule.date].push(schedule)
		} else {
			closedDates[schedule.date] = [schedule]
		}
	})
	return (
		<div className='flex flex-col gap-4'>
			{Object.keys(closedDates).map((date: string) => (
					<div key={date} className='flex flex-col gap-2'>
						<p className="font-bold text-sm text-blue-secondary">{new Date(Number(date)).toLocaleDateString('en-US', {timeZone: "Asia/Makassar", day: "2-digit", month: "long", year: "numeric"})}</p>
						<div className="flex gap-2 flex-wrap">
							{formatClosingHours(closedDates[date]).map(closedDuration => (
								<>
									{Object.keys(closedDuration.startHour).map((closedPeriod) => (
										<div className='flex flex-col py-2 px-4 border border-grey-line-subtle rounded-sm'>
											<p className='medium text-xs text-primary-black'>{closedDuration.name}</p>
											<p className='text-xs text-grey-dark'>{`${closedDuration.startHour[closedPeriod].start}.00 - ${closedDuration.startHour[closedPeriod].end}.00 WITA`}</p>
										</div>
									))}
								</>
							))}
						</div>
					</div>
				)
			)}
		</div>
	)
}
export const renderStatusRow = (status: string) => {
	const bgColor = status === 'DONE' ? 'bg-green-subtle' : 'bg-blue-subtle'
	const textColor = status === 'DONE' ? 'text-green-success' : 'text-sm font-medium text-blue-light'

	return (
		<div className="flex justify-start p-0">
			<div className={`flex justify-center items-center px-4 py-3 gap-3 rounded-sm ${bgColor}`}>
				<p className={`font-medium text-sm ${textColor}`}>{status}</p>
			</div>
		</div>
	)
}
export const renderTableEditButton = (v: string, navigate: Function) => (
	<div>
		<Button
			className="border border-grey-line-subtle"
			type='button'
			variant='basic'
			onClick={() => navigate(`/dashboard/calendar/closed-schedule/edit/${v}`)}>
			<EditIcon/>
			Edit
		</Button>
	</div>
)

export const HEADERS: TableHeader[] = [
	{
		label: 'REASON',
		key: 'reason'
	},
	{
		label: 'Schedule',
		key: 'schedule'
	},
	{
		label: 'STATUS',
		key: 'status'
	},
	{
		label: 'ACTION',
		key: 'action'
	}
]
export const SORT: TableSort = {
	type: 'SERVER',
	handler: () => {}
}
export const META: TableSummarizeMeta = {
	startItem: 1,
	endItem: 20,
	totalItem: 2290,
	pageNumber: 1,
	lastPage: 20
}
